// import axios from "../../../axios";
import axios from "axios";
const appUrl: string | undefined = process.env.REACT_APP_API_URL;

export function fetchLogin(payload: any) {
  const response = axios.post(`${appUrl}/accounts/login/`, payload);
  return response;
}
export function fetchVerifyOTP(payload: any) {
  const response = axios.post(
    `${appUrl}/accounts/verify-otp/`,
    payload
    // {
    //   mobile_number: payload.mobile_number,
    //   OTP: payload.OTP,
    // }
    // {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // }
  );
  return response;
}
